import i18n from "../i18nNext";
import { _isCommaAsDecimalSeprator } from "./countryWiseLanguageCode";

module.exports = {
    _amountValidation: function(value, maxLimit, currencyConstuctBit, withoutDecimalAmountBit) {
        if (value == "") return value;

        let formatLng = this._getLanguageFormat(i18n.language);

        if (_isCommaAsDecimalSeprator(formatLng)) {
            if (value.includes(",")) {
                value = value.replace(",", ".");
            } else if (value.includes(".")) {
                return -1;
            }
        }

        // var pattern = /\s/g;
        if (isNaN(value) || value.match(/\s/g) || (maxLimit && value >= maxLimit)) {
            return -1;
        } else {
            value = value.replace(/[+-]/g, "");
            if (currencyConstuctBit) {
                if (value.indexOf(".") >= 0 && value.split(".")[1].length > 6) {
                    return -1;
                } else if (value == 0 && !value.match(/\./g)) {
                    return 0;
                }
                return value;
            } else {
                if (withoutDecimalAmountBit) {
                    if (value.indexOf(".") !== -1) {
                        return -1;
                    }
                    return value;
                } else {
                    if (value.indexOf(".") >= 0 && value.split(".")[1].length > 3) {
                        return -1;
                    } else if (value == 0 && !value.match(/\./g)) {
                        return 0;
                    }
                    return value;
                }
            }
        }
    },
    //check for alphabet only
    _isAlphabet: function(value) {
        // return /^[a-zA-Z]*$/.test(value);
        return /^([a-zA-Z]?)*$/.test(value);
    },

    _amountValidationTwoDecimalPlace: function(value, maxLimit, currencyConstuctBit) {
        if (value == "") return value;

        // var pattern = /\s/g;
        if (isNaN(value) || value.match(/\s/g) || (maxLimit && value >= maxLimit)) {
            return -1;
        } else {
            value = value.replace(/[+-]/g, "");
            if (currencyConstuctBit) {
                if (value.indexOf(".") > 0 && value.split(".")[1].length > 6) {
                    return -1;
                } else if (value == 0 && !value.match(/\./g)) {
                    return 0;
                }
                return value;
            } else {
                if (value.indexOf(".") > 0 && value.split(".")[1].length > 2) {
                    return -1;
                } else if (value == 0 && !value.match(/\./g)) {
                    if (value.length > 1) return -1;
                    return 0;
                }
                return value;
            }
        }
    },

    _isValidEmail: function(email) {
        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regex.test(email)) {
            return true;
        }
        return false;
    },

    _textFieldValidation: function(textStr) {
        let str = textStr || "";
        if (!str.trim()) {
            str = str.trim();
        } else if (str.length > 0 && str.trim()) {
            if (str.length - str.trim().length > 1) {
                str = str.substr(0, str.length - 1);
            }
        }
        return str;
    },

    _numberValidation: function(evt) {
        var pattern = /\s/g;
        if (
            evt.target.value.match(pattern) ||
            isNaN(evt.target.value) ||
            evt.target.value.indexOf(".") > 0
        ) {
            return false;
        }
        return true;
    },

    //check if no is interger or not
    _isValidInteger: function(value) {
        return /^\d+$/.test(value);
    },

    //check whether no is numeric or not, it will accept the decimal value also
    _isNumeric: function(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    },
    //check the value is valid GSTIN or not
    _isGstin: function(value) {
        return /^[0-4]{1}[0-9]{1}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);
    },

    /*check whether value is alphanumeric or not like IFSC code validation 
	it will not allow decimal, any special character*/
    _isAlphaNumeric: function(value) {
        return /^[A-Za-z0-9]+$/i.test(value);
    },

    _latestVinayNumberValidation: function(evt) {
        let value = evt.target.value;
        if (isNaN(value) || value.match(/\s/g)) {
            return false;
        } else {
            return true;
        }
    },

    _IPAddressValidate: function(val) {
        if (
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\/(?:[0-9]|[12][0-9]|3[0-2]))?$/.test(
                val
            )
        ) {
            return false;
        } else {
            return true;
        }
    },

    _getAmountValue: function(amount) {
        let formatLng = this._getLanguageFormat(i18n.language);
        if (_isCommaAsDecimalSeprator(formatLng) && amount && `${amount}`.includes(".")) {
            if (amount >= 0) {
                amount = `${amount}`.replace(".", ",");
            }
        }
        return amount;
    },

    _getLanguageFormat: function(lng) {
        let formatLng = lng || i18n.language;
        if (formatLng.split("-")[1]) {
            formatLng = `${formatLng.split("-")[0]}-${formatLng.split("-")[1].toUpperCase()}`; // convert second part in caps like: en-in to en-IN
        }
        return formatLng;
    },

    _amountValidationUpToGivenDecimalPlace: function(
        value,
        upToPlace = 2,
        maxLimit = 10000000000000
    ) {
        if (value == "") return value;

        if (isNaN(value) || value.match(/\s/g) || (maxLimit && value >= maxLimit)) {
            return -1;
        } else {
            value = value.replace(/[+-]/g, "");
            if (value.indexOf(".") > 0 && value.split(".")[1].length > upToPlace) {
                return -1;
            } else if (value == 0 && !value.match(/\./g)) {
                if (value.length > 1) return -1;
                return 0;
            }
            return value;
        }
    },
    _chassisNumberValidator: function(value) {
        return /[a-zA-Z0-9]{9}[a-zA-Z0-9-]{2}[0-9]{6}/.test(value);
    },
    _rcNumberValidator: function(value) {
        return /[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}/.test(value);
    },
    isValidDate: function(d) {
        return d instanceof Date && !isNaN(d);
    }
};
